
import TabArticles from '../TabArticles';
import SeoUtil from '../SeoUtil';


const HealthTab = () => {
  const tab_title = 'Novinky zo sveta zdravia'
  const url_category = 'health'

  return (<>
    <SeoUtil
      title={`Mudrosti Sveta | ${tab_title}`}
      description={tab_title}
      name='Mudrosti Sveta'
      type='articles' />
    <TabArticles tab_title={tab_title} url_category={url_category} />
  </>
  );
};

export default HealthTab;